import React, { useEffect } from 'react'

import { StyleSheet, Keyboard, Platform, Image, View } from 'react-native'
import { KeyboardAwareScrollView } from '../Components'
import AppConfig from '../Configuration/AppConfig'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import client from '@sart/client'
import { useContent } from '@sart/content'
import { prettyErrorMessage, testID } from '@sart/utilities'
import { adaptive, backgroundColors, colors, typography } from '@sart/styles'

import { SafeAreaView } from 'react-native-safe-area-context'

import {
  Title,
  Description,
  TextInputExtended,
  Select,
  Button,
  Space,
  CheckBox,
  Text,
  KeyboardAvoidingView,
  Label,
  AnimatedEllipsis
} from '@sart/components'

import NeedHelpFooter from '../NeedHelpFooter'
import * as theme from './signTheme'

import ApiClient from '../bff-client/src/ApiClient'
import CustomersApi from '../bff-client/src/api/CustomersApi'

export default function SignUpRegisterDetails(props) {
  const content = useContent()
  const {
    customerDetails,
  } = client.cache

  const { navigation, route } = props

  const bffClient = new ApiClient(AppConfig.bffBasePath)
  bffClient.defaultHeaders = {
    ...bffClient.defaultHeaders,
    Origin: AppConfig.shopOriginUrl
  }
  const customersApi = new CustomersApi(bffClient)

  useEffect(() => {
    // handleRegisterDetails()
  }, [])

  const number = route.params?.number
  const email = route.params?.email
  const password = route.params?.password

  const formik = useFormik({
    initialValues: {
      dob: '',
      marketingEmail: false,
      marketingSms: false,
    },
    validationSchema: Yup.object().shape({
      dob: Yup.string().required(content.forms.required),
    }),
    onSubmit: finaliseRegistration
  })


  function blockSpecialCharacters(value) {
    if (value) {
      if (value.match(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s'-]+$/)) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }

  function validatePostcode(value) {
    if (value) {
      return value.match(/^\d{5}$/)
    } else {
      return true
    }
  }

  async function finaliseRegistration(values, form) {
    Keyboard.dismiss()
    //console.log('values = ' + JSON.stringify(values))
    const dobVal = values.dob
    const isoDate = dobVal.substring(6, 10) + '-' + dobVal.substring(3, 5) + '-' + dobVal.substring(0, 2)
    const dobDate = new Date(isoDate)

    if (dobVal.substring(3, 5) > 12) {
      form.setFieldError('dob', 'Please enter a valid date in the format dd-mm-yyyy')
      form.setFieldTouched('dob', true, false)
      form.setSubmitting(false)
      return
    }

    //check that the date is not in the future
    if (dobDate > new Date()) {
      form.setFieldError('dob', 'Date of birth cannot be in the future')
      form.setFieldTouched('dob', true, false)
      form.setSubmitting(false)
      return
    }

    //we need to do the full registration here
    //1. Invoke the BFF API to register the customer with the password
    //2. Update the customer in the SSB with the communication prefs and DOB
    try {

      const registrationReq = {
        "email": email,
        "password": password,
        "passwordConfirmation": password
      }

      const registrationResp = await customersApi.customersRegisterPost(registrationReq)
      console.log('registrationResp is ' + JSON.stringify(registrationResp, null, 2))

      /*
      registrationResp is {
        "tokenId": "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIyNDc5IiwiaWF0IjoxNzgwOTI3MTI1LCJzdWIiOiJTU0IiLCJpc3MiOiJWQURTQSIsImV4cCI6MTc4MDkzMDcyNX0.nQrsj4gXE5hSVic8spu4lKeTX4FrJAlnS7TqQrYwNh0",
        "userId": "2479",
        "customerId": "2411"
      }
      */

      //now set up the client headers as we can authenticate
      console.log('signing in with email: ' + email + ' and password: ' + password)
      const auth = await client.signInWithMobileAndPassword({ username: email, password })
      console.log('auth is ' + JSON.stringify(auth, null, 2))


      //add the DOB to the reg details
      var registrationDetails = {
        primaryIdentifier: number,
        operatorCode: AppConfig.operatorCode,
        dob: isoDate,
        gender: 'M',
        emailAddress: email,
        primaryContactNumber: '00000000000',
        primaryContactNumberCountryCode: "+44"
      }

      const modifyUserResult = await client.callApi('registration', 'modifyUserRegistration', [
        auth.userId,
        registrationDetails
      ])

      console.log('modifyUserResult is ' + JSON.stringify(modifyUserResult, null, 2))


      const user = await client.callApi('user', 'getUser', [auth.userId])
      console.log('user is ' + JSON.stringify(user, null, 2))

      const customerResponse = await client.callApi('user', 'getUserCustomers', [auth.userId])
      const customer = customerResponse[0]

      console.log('customer is ' + JSON.stringify(customer, null, 2))

      let communicationPrefs = customer?.communicationPreferences

      if (communicationPrefs) {
        communicationPrefs.receiveEmail = values.marketingEmail
        communicationPrefs.receiveSms = values.marketingSms
      }

      //modifyCommunicationPreference(customerId, communicationpreferenceId, communicationPreferences)
      const modifyCustomerResult = await client.callApi('customer', 'modifyCommunicationPreference', [
        customer.customerId,
        communicationPrefs.id,
        communicationPrefs
      ])

      console.log('modifyCustomerResult is ' + JSON.stringify(modifyCustomerResult, null, 2))

      client.setCache({ customerId: customer.customerId })
      // orderHelper.activateService(customerId)

      //fire off the registration to the bff - we do not care about the response (fire and forget)
      customersApi.customersSubscriptionsRegisterPut({
        email: email,
        registered: true
      })

      navigation.navigate('Main', { customerId: customer.customerId, userId: user.userId })
    } catch (error) {
      console.log('error ' + JSON.stringify(error, null, 2))
      if (error.response && error.response.body &&
        (error.response.body.messageCode === "SR0015" || error.response.body.code === 'MUST_CHANGE_PASSOWRD')) {
        //if must change password, redirect to password change screen
        await handleMustChangePassword()

      } else {
        const message = prettyErrorMessage(error, content)
        form.setFieldError('dob', message)
        form.setSubmitting(false)
      }
    }
  }

  async function handleMustChangePassword() {
    const auth = await client.callApi('authentication', 'createToken')
    await client.storeAuthInformation(auth)
    await client.cacheAuthInformation(auth)
    client.setupHeaderBearerAuth(client.cache.token)

    const user = await client.callApi('user', 'getUser', [auth.userId])

    const params = {
      ...auth,
      userId: client.cache.userId,
      emailAddress: user.userName
    }
    navigation.navigate('ForgottenPasswordNewPassword', params)
  }

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView style={styles.content}>

        <View style={styles.logo}>
          <Image
            source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
            //height={styles.logoStyle.height} width={200} alignSelf={"center"}
            style={styles.logoImage}
          />
          {/* <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} alignSelf={"center"} /> */}
        </View>
        <Space height={24} />
        <Title style={styles.title}>{content.register_details.title}</Title>

        <Space height={24} />

        <TextInputExtended
          label={content.forms.dobLabel}
          value={formik.values.dob}
          placeholder={content.forms.dobPlaceholder}
          keyboardType="numeric"
          maxLength={10}
          {...Platform.select({
            web: { autoComplete: 'bday' },
            ios: { textContentType: 'birthdate' },
            android: { autoComplete: 'birthdate-full' }
          })}
          onChangeText={(text) => {
            const cleaned = text.replace(/[^0-9]/g, '');
            let formatted = cleaned;
            if (cleaned.length > 2) {
              formatted = `${cleaned.slice(0, 2)}-${cleaned.slice(2)}`;
            }
            if (cleaned.length > 4) {
              formatted = `${cleaned.slice(0, 2)}-${cleaned.slice(2, 4)}-${cleaned.slice(4, 8)}`;
            }
            formik.setFieldValue('dob', formatted);
          }}
          onBlur={() => formik.setFieldTouched('dob', true, false)}
          error={formik.errors.dob}
          {...theme.textInput}
          {...testID('SignUpDetailsDob')}
        />

        <Space height={24} />

        <Label>{content.register_details.marketingCommsConsent}</Label>
        <Space height={24} />
        <View style={styles.checkboxWrapper}>
          <CheckBox
            value={formik.values.marketingEmail}
            onPress={() => formik.setFieldValue('marketingEmail', !formik.values.marketingEmail)}
            webSize={14}
            style={styles.checkbox}
            tintColors={{ true: colors.brightOrange, false: colors.white }}
            checkedColor={colors.brightOrange}
            borderColor={colors.brightOrange}
            disabledBorderColor={colors.white}
            tickColor={colors.white}
            {...testID('SignUpDetailsMarketingEmail')}
          />
          <Space width={12} />
          <Label style={styles.checkboxLabel}>email</Label>
        </View>

        <Space height={16} />

        <View style={styles.checkboxWrapper}>
          <CheckBox
            value={formik.values.marketingSms}
            onPress={() => formik.setFieldValue('marketingSms', !formik.values.marketingSms)}
            webSize={14}
            style={styles.checkbox}
            tintColors={{ true: colors.brightOrange, false: colors.white }}
            checkedColor={colors.brightOrange}
            borderColor={colors.brightOrange}
            disabledBorderColor={colors.softGray}
            tickColor={colors.white}
            {...testID('SignUpDetailsMarketingSms')}
          />
          <Space width={12} />
          <Label style={styles.checkboxLabel}>SMS</Label>
        </View>

        <Space height={24} />

        <Button
          title={
            formik.isSubmitting
              ? <AnimatedEllipsis style={{ fontSize: 24, color: colors.clear, ...typography.extrabold }} />
              : content.register_details.action
          }
          disabled={!formik.isValid || !!formik.errors.dob || formik.isSubmitting || !formik.values.dob || formik.values.dob.length !== 10}
          onPress={formik.handleSubmit}
          {...theme.button}
          titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
          disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white + 45 }}
          {...testID('SignUpDetailsSubmit')}
        />

        {/* <ReturnFooter
        style={styles.cancelStyle}
        title={content.common.cancel}
        onPress={() => navigation.navigate('SignIn')}
      /> */}

      </KeyboardAvoidingView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    alignItems: 'center'
  },
  content: {
    flex: 1,
    ...adaptive.wrapperPadding,
    //justifyContent: 'center'
    maxWidth: 600,
  },
  title: {
    color: colors.clear,
    ...typography.lightbold
  },
  description: {
    textAlign: 'center'
  },
  selectStyle: {
    ...typography.demi
  },
  cancelStyle: {
    color: colors.white
  },
  logoStyle: {
    ...adaptive.guruSize
  },
  checkboxWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8
  },
  checkbox: {
    padding: 0,
    margin: 0
  },
  checkboxLabel: {
    ...typography.lightbold,
    color: colors.white,
    flex: 1,
    flexWrap: 'wrap'
  },
  logoImage: {
    height: 45,
    width: 45,
    position: 'relative',
    alignSelf: 'center',
    width: 200,
    ...adaptive.guruSize
  }
})
